module.exports = __webpack_public_path__ + "media/images/shop/icon-service-d993b95bf0f30e9adb99ef2cd16cfa6a.svg";